import React from 'react';
import { breakpoints, colors } from '../config';

const Title = ({ children, ...rest }) => (
  <h2 {...rest}>
    {children}

    <style jsx>{`
      h2 {
        font-size: 21px;
        font-weight: bold;
        line-height: 1.25;
        margin-bottom: 32px;
        margin-top: 32px;
      }

      @media screen and (min-width: ${breakpoints.md}) {
        h2 {
          font-size: 28px;
          font-weight: 900;
          font-family: ${colors.baseFontDisplay};
        }
      }
    `}</style>
  </h2>
);

export default Title;
